import types from 'constants/actionTypes';
import { combineReducers } from 'redux';
import { find, remove } from 'lodash';

const initialState = {
  byId: {},
  filters: {
    priceBands: [],
    functionalOptions: [],
    paintOptions: [],
    interiorOptions: [],
  },
};

const updateFilterOptions = (options, updatedOptions) =>
  options.map(option => {
    const updatedOption = find(
      updatedOptions,
      filter => filter.featureCode === option.featureCode,
    );
    updatedOption ? (option.count = updatedOption.count) : (option.count = 0);
    return option;
  });

const byId = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.byId;
  }

  switch (type) {
    case types.GET_MODEL_ADVANCED_REQUEST_SUCCESS:
      let updatedState = { ...state };
      const modelId = payload.vgModelCode;
      updatedState[modelId] = payload;
      return updatedState;
    case types.GET_MODEL_ADVANCED_WITH_FILTERS_REQUEST_SUCCESS:
      updatedState = { ...state };
      const {
        paintOptions,
        interiorOptions,
        priceBands,
        functionalOptions,
      } = payload;
      const prevPaintOptions = updatedState[payload.vgModelCode].paintOptions;
      const prevInteriorOptions =
        updatedState[payload.vgModelCode].interiorOptions;
      const prevFunctionalOptions =
        updatedState[payload.vgModelCode].functionalOptions;

      let newPriceBands = updatedState[payload.vgModelCode].priceBands.map(
        priceBand => {
          const updatedPriceBand = find(
            priceBands,
            filteredPriceBand =>
              filteredPriceBand.priceBand.id === priceBand.priceBand.id,
          );
          updatedPriceBand
            ? (priceBand.count = updatedPriceBand.count)
            : (priceBand.count = 0);
          return priceBand;
        },
      );

      let newPaintOptions = updateFilterOptions(prevPaintOptions, paintOptions);
      let newInteriorOptions = updateFilterOptions(
        prevInteriorOptions,
        interiorOptions,
      );
      let newFunctionalOptions = updateFilterOptions(
        prevFunctionalOptions,
        functionalOptions,
      );

      updatedState[payload.vgModelCode] = payload;
      updatedState[payload.vgModelCode].priceBands = newPriceBands;
      updatedState[payload.vgModelCode].paintOptions = newPaintOptions;
      updatedState[payload.vgModelCode].interiorOptions = newInteriorOptions;
      updatedState[
        payload.vgModelCode
      ].functionalOptions = newFunctionalOptions;

      return updatedState;
    default:
      return state;
  }
};

const filters = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState.filters;
  }

  switch (type) {
    case types.ADD_ADVANCED_FILTERS:
      let updatedState = { ...state };
      const filterType = payload.filterType;
      updatedState[filterType].push(payload.code);
      return updatedState;
    case types.DELETE_ADVANCED_FILTERS:
      updatedState = { ...state };
      remove(updatedState[payload.filterType], code => code === payload.code);
      return updatedState;
    case types.CLEAR_ADVANCED_FILTERS:
      const priceBands = [];
      const functionalOptions = [];
      const paintOptions = [];
      const interiorOptions = [];
      return { priceBands, functionalOptions, paintOptions, interiorOptions };
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  filters,
});
